"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const taquito_1 = require("@taquito/taquito");
const signer_1 = require("@taquito/signer");
class LiquidityPoolClient {
    constructor(nodeUrl, wallet, liquidityPoolAddress) {
        this.liquidityPoolAddress = liquidityPoolAddress;
        const tezos = new taquito_1.TezosToolkit(nodeUrl);
        if (wallet instanceof signer_1.InMemorySigner) {
            tezos.setProvider({ signer: wallet });
        }
        else {
            tezos.setWalletProvider(wallet);
        }
        this.tezos = tezos;
    }
    async liquidate(targetOvenAddress) {
        const liquidityPoolContract = await this.tezos.wallet.at(this.liquidityPoolAddress);
        const sendArgs = { amount: 0, mutez: true };
        return await liquidityPoolContract.methods['liquidate'](targetOvenAddress).send(sendArgs);
    }
}
exports.default = LiquidityPoolClient;
//# sourceMappingURL=liquidity-pool-client.js.map